import axios from 'axios';
import qs from 'qs';
import urls from '@/settings/urls';

export const GetShippingCarriers = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.shipping_carriers
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateShippingCarrier = (data) => {
  let requestOptions = {
    method: 'POST',
    url: urls.admin.shipping_carriers,
    data: {
      shipping_carrier: data
    },
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateShippingCarrier = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.admin.shipping_carriers}/${data.provider}`,
    params: {
      shipping_carrier: {
        credentials: data.credentials
      }
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const RemoveShippingCarrier = (provider) => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.shipping_carriers}/${provider}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const ShippingInfo = (data) => {
  let requestOptions = {
    method: 'POST',
    url: urls.admin.shipping_info,
    data,
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetAvailableCarriers = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.available_carriers
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetShippingRates = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.mail_items}/${data.id}/shipping_rates`,
    params: data.params,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const TrackShipping = (mail_id) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.mail_items}/${mail_id}/shipment_tracking`
  }

  return axios(requestOptions)
    .then(res => res.data);
}


export const CustomerTrackShipping = (mail_id) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.mail_items}/${mail_id}/shipment_tracking`
  }

  return axios(requestOptions)
    .then(res => res.data);
}